import TaskHeading from "./TaskHeading";

/** One task from an agent-authored checkpoint, with no inferred child steps. */
export default function TaskRow({ task, streaming = false }) {
  return <TaskHeading task={task} streaming={streaming} />;
}
